// Lightweight device fingerprint — no external library.
// Produces a stable ~40-char hex string from browser signals.
// Not infallible, but catches the majority of same-device multi-account attempts.

async function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 50;
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('OpenHosst🌐', 2, 15);
    ctx.fillStyle = 'rgba(102,204,0,0.7)';
    ctx.fillText('OpenHosst🌐', 4, 17);
    return canvas.toDataURL().slice(-50);
  } catch {
    return '';
  }
}

function getWebGLFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return '';
    const ext = gl.getExtension('WEBGL_debug_renderer_info');
    if (!ext) return '';
    return [
      gl.getParameter(ext.UNMASKED_VENDOR_WEBGL),
      gl.getParameter(ext.UNMASKED_RENDERER_WEBGL),
    ].join('|');
  } catch {
    return '';
  }
}

async function hashString(str) {
  try {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 40);
  } catch {
    // Fallback: simple djb2 hash
    let h = 5381;
    for (let i = 0; i < str.length; i++) h = ((h << 5) + h) ^ str.charCodeAt(i);
    return Math.abs(h).toString(16).padStart(8, '0');
  }
}

export async function getDeviceFingerprint() {
  try {
    const canvas = await getCanvasFingerprint();
    const webgl = getWebGLFingerprint();
    const signals = [
      navigator.userAgent,
      navigator.language,
      navigator.languages?.join(',') || '',
      window.screen.width + 'x' + window.screen.height,
      window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || '',
      navigator.deviceMemory || '',
      navigator.platform || '',
      window.devicePixelRatio || '',
      canvas,
      webgl,
      (navigator.plugins?.length || 0),
    ].join('|||');
    return await hashString(signals);
  } catch {
    return null;
  }
}
